import React from 'react';

const CardProfileCards = () => {
  return (
      <div className='flex flex-col gap-2 w-full h-full'>
        <h4 className='font-semibold'>Cartões</h4>
        <div className='grid h-full gap-2 grid-cols-2 min-h-32'>
          <div className='w-full h-full bg-gray-100 rounded-md'></div>
          <div className='w-full h-full bg-gray-100 rounded-md'></div>
          <div className='w-full h-full bg-gray-100 rounded-md'></div>
        </div>
      </div>
  );
};

export default CardProfileCards;